import * as React from "react";
import { inject, observer } from "mobx-react";
import Header from "../header/Header";
import Filter from "../filter/Filter";
import Announcement from "../announcement/Announcement";
import Scanner from "../scanner/Scanner";
import BrowserNotification from "../browsernotification/BrowserNotification";
import { AppProps } from "../../stores/storeContract";
import { View } from "../../stores/commonStore";
import Settings from "../settings/Settings";
import toastNotificationHelper from "../../helpers/toastNotificationHelper";
 import Loader from "../loader/Loader";
import { findDOMNode } from "react-dom";
import Navigation from "../navigation/navigation";
import { action } from "mobx";
import "./Home.scss";


@inject("notificationStore", "userStore", "commonStore", "settingsStore", "filterStore", "scannerStore", "symbolStore")
@observer
export default class Home extends React.Component<AppProps> {

	darkTheme: boolean = undefined;
	startTime: number;
	private themeTimerId: NodeJS.Timeout;

	componentDidMount() {

		this.startTime = new Date().getTime();

		// try one by one		
		this.props.symbolStore.initSymbolNameDetails().then(() => {
			console.log('[Home] InitSymbolNameDetails resolved');
			this.props.settingsStore.initSettings().then(() => {		
				console.log('[Home] InitSettings resolved');		
				this.props.filterStore.initFilters().then(() => {
					console.log('[Home] InitFilters resolved');	
					if (this.props.userStore.isAdmin) {
						this.props.symbolStore.getSyncedSymbols().then(() => {		
							console.log('[Home] GetSyncedSymbols resolved');		
							this.onAppLoaded();				
						}, () => {console.log('[Home] GetSyncedSymbols rejected');});
					} else {
						this.onAppLoaded();
					}					
				}, () => {console.log('[Home] InitFilters rejected');});				
			}, () => {console.log('[Home] InitSettings rejected');});			
		}, () => {console.log('[Home] InitSymbolNameDetails rejected');});		
	}

	componentDidUpdate() {
		this.tryUpdateTheme();		
	}

	onAppLoaded(): void {

		this.props.commonStore.appLoaded = true;			
		this.checkSoundFirstInteraction();

		var elapsed = (new Date()).getTime() - this.startTime;
		console.log('[Home] Initial load done in ' + elapsed + ' ms');

		this.themeTimerId = setInterval(this.onThemeTimerElapsed, 100);
	}

	@action.bound onThemeTimerElapsed(): void {
		console.log('[Home] trying change theme via timer');
		this.tryUpdateTheme();
	}

	@action.bound tryUpdateTheme(): void {
		var shouldCancelTimer = true;

		if (this.props.commonStore.darkTheme != this.darkTheme){
			console.log('[Home] changing theme...');
			this.darkTheme = this.props.commonStore.darkTheme;

			var currentElement = findDOMNode(this) as Element;
			if (currentElement != null) {
				var rootElement = currentElement.closest(":root");
				rootElement.className = this.darkTheme ? 'dark-theme' : 'light-theme';
			}
			else {
				console.log('[Home] currentElement not found');
				shouldCancelTimer = false;
			}			
		}

		if (shouldCancelTimer && this.themeTimerId != null){
			console.log('[Home] theme timer canceled');
			clearInterval(this.themeTimerId);
		}	
	}

	checkSoundFirstInteraction() {
		var isFirstLoad = this.props.notificationStore.soundNeedFirstInteraction;
		if (isFirstLoad) {
			this.props.notificationStore.soundNeedFirstInteraction = false;
			var id = toastNotificationHelper.notifyInfo('Sound are muted');
			this.props.notificationStore.soundMutedToastId = id;
		}
	}

	render() {
		 
		const { view, darkTheme, appLoaded } = this.props.commonStore; // !!! leave darkTheme and appLoaded here to trigger componentDidUpdate

		return (
			<div className="home">
				<Navigation {...this.props} />
				<Loader {...this.props} />
				<BrowserNotification {...this.props} />
				<Announcement {...this.props} />
				<Header {...this.props} />
				{
					view == View.Scanner
						? <div className="row no-gutters home-content-row">
							<div className="col-xl-1-75 col-md-3 no-padding left-col">
								<div className="home-panel home-panel-left">
									<div className="home-filter-panel">
										<Filter {...this.props} />
									</div>
								</div>           
							</div>
							<div className="col-xl-10-25 col-md-9 no-padding">
								<div className="home-panel home-panel-right no-left-margin">
									<div className="home-scanner-panel">
										<Scanner {...this.props} />
									</div>
								</div>            
							</div>
						</div>
						: <div className="row no-gutters home-content-row">
							<div className="col-md-12 no-padding">
								<div className="home-panel home-panel-center">
									{/* {
										{
											[View.Settings]: <Settings  {...this.props} />,
											[View.Maintenance]: <Maintenance  {...this.props} />
										}[view]
									} */}

									<Settings {...this.props} />
								</div>
							</div>
						</div>
				}
			</div>
		);
	}
}